import { httpService } from './http.service'
import { utilService } from './util.service.js'

const CACHE_EXPIRY_DAYS = 7 // זמן תוקף הנתונים בלוקאל סטורג'
const CACHE_EXPIRY_TIME = CACHE_EXPIRY_DAYS * 24 * 60 * 60 * 1000 // זמן במילישניות
let cache = {} // קאש בזיכרון (RAM)

// 📌 **פונקציה לקבלת היום הנוכחי באנגלית**
export const getCurrentDay = () => {
  const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
  return days[new Date().getDay()]
}

// 📌 **משיכת לוח שידורים מהשרת לפי יום עם Cache חכם**
export async function getByDay(day) {
  const cacheKey = `animeSchedules-${day}`
  const cacheExpirationKey = `${cacheKey}-expiration`
  const now = Date.now()

  // 🔹 1️⃣ בדיקה בזיכרון (RAM)
  if (cache[cacheKey]) {
    return cache[cacheKey]
  }

  // 🔹 2️⃣ בדיקה ב-LocalStorage
  const cachedData = utilService.getFromLocalStorage(cacheKey)
  const cachedExpiration = utilService.getFromLocalStorage(cacheExpirationKey)

  if (cachedData && cachedExpiration && now < cachedExpiration) {

    // ✅ שומרים בזיכרון לשימוש מהיר יותר
    cache[cacheKey] = cachedData
    return cachedData
  }

  // 🔹 3️⃣ אם הנתונים לא נמצאים או פגו תוקף → מביאים מהשרת
  try {
    const data = await httpService.get(`animefeatures/schedules?day=${day}`)


    if (data.length) {
      // ✅ שומרים בזיכרון (RAM)
      cache[cacheKey] = data

      // ✅ שומרים גם ב-LocalStorage
      utilService.saveToLocalStorage(cacheKey, data)
      utilService.saveToLocalStorage(cacheExpirationKey, now + CACHE_EXPIRY_TIME)
    }

    return data
  } catch (error) {
    console.error('❌ שגיאה במשיכת לוח השידורים:', error)
    return []
  }
}

// 📌 **משיכת לוח שידורים ליום הנוכחי בלבד**
export async function fetchTodayAnimeSchedule() {
  const currentDay = getCurrentDay()
  return await getByDay(currentDay)
}
